var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.file && _vm.file_data)?_c('a',{staticClass:"link",attrs:{"target":"_blank","rel":"noreferrer","href":_vm.file_data.data.data.full_url}},[_vm._v("Learn More")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }